import React from 'react'
import { Link } from "react-router-dom";
import "./Navbar.css";
import Logo from "../images/elite medical care logo.jpg";





function Navbar() {
  return (
    <div>
      <div className='fixed-top'>
        <div className="questcolor">
          <div className="album py-1">

            <div className="container">

              <div className="row ">

                <div className="col-md-6" >
                  <div className="d-flex justify-content-between align-items-center">

                    <a style={{ color: "white" }} className="" href="tel: +91 9732775201"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
</svg> +91 9732775201  </a>


                    <a target="_blank" rel="noopener noreferrer" href="find-doctor">
                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style={{color:"white"}} class="bi bi-person-plus" viewBox="0 0 16 16">
  <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"/>
  <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5"/>
</svg> <small className='mt-1' style={{ color: "white" }} >Find Doctor</small>
                    </a>





                  </div>

                </div>

                <div className="d-flex justify-content-between align-items-center">





                </div>
              </div>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-expand-lg navbar-light bg-light shadow ">
          <div className="container-fluid ">
            <Link to="/" style={{ color: "maroon" }} >
              <img src={Logo} height="44px" className='me-0' weight="95px" alt="logo" />

            </Link>

         


            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link to="/" className="nav-link active my-btn" aria-current="page" href="#"><b>Home</b></Link>
                </li>
                    <li className="nav-item">
                  <a href="about-us" className="nav-link my-btn" ><b>About us</b></a>
                </li>
                  <li className="nav-item">
                  <a href="find-doctor" className="nav-link my-btn" ><b>Find Doctors</b></a>
                </li>

            
                <li className="nav-item">
                  <a href='labtest'  className="nav-link my-btn" ><b>Labtest</b></a>
                </li>

                <li className="nav-item">
                  <Link to="#" className="nav-link my-btn" href="#"><b>Health Package</b></Link>
                </li>
             

              
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle my-btn" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b> Services</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a href="Radiology" className="dropdown-item my-btn">Radiology </a></li>
                    <li><Link to="/" className="dropdown-item my-btn" href="#">Pathology</Link></li>
                  
                    <li><Link to="/find-doctor" className="dropdown-item" href="#">Polyclinic</Link></li>

                  </ul>
                </li>
                <li className="nav-item">
                  <Link to="/contact-us" className="nav-link my-btn" href="#"><b>Contact us</b></Link>
                </li>
              </ul>

              <a href='tel: +91 9732775201'>
                <button className="elitemedical" type="submit">+91 9732775201</button>
              </a>

            </div>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Navbar